import { Center, Dialog } from "@chakra-ui/react";
import LoadingIndicator from "components/ui/LoadingIndicator"

export default function ProgressModal({ message }) {
    return (
        <Dialog.Root open={!!message} size="xs" placement="center">
            <Dialog.Backdrop />
            <Dialog.Positioner>
                <Dialog.Content>
                    <Dialog.Body bgColor="darkblue.500" borderRadius={5}>
                        <Center>
                            <LoadingIndicator label={message} />
                            {/*<Flex direction="column" align="center" p={8} width="300px" m="auto" textAlign="center">*/}
                            {/*    <Spinner thickness="3px" speed="0.45s" color="darkblue.100" size="xl" />*/}
                            {/*    <Text color="darkblue.100" mt={6}>*/}
                            {/*        {message}*/}
                            {/*    </Text>*/}
                            {/*</Flex>*/}
                        </Center>
                    </Dialog.Body>
                </Dialog.Content>
            </Dialog.Positioner>
        </Dialog.Root>
    );
}
